import selectors from '../rootSelectors';
import { CLPL_FETCH_RETRY } from '../common/api/apiRetryGetConstants';
import CLPLServiceClient from '../common/clients/CLPLServiceClient';
import { COMPREHENSION, CLPL } from '../constants/measure';
import { getStudentResults, saveMeasureResponse } from '../common/api/clplApiActions';

import { setMazeContent, formatMazeResponses } from '../maze/mazeActions';

const measure = CLPL.MEASURE;
const measureType = COMPREHENSION;

export const fetchCLPLContent = () => (dispatch, getStore) => {
    const state = getStore();
    const form = selectors.findNextForm(state, measure, measureType);
    return dispatch(CLPLServiceClient.getForm(null, null, form.id, CLPL_FETCH_RETRY))
        .then((contentJson) => {
            if (contentJson) {
                dispatch(setMazeContent(contentJson));
            }
        });
};

export const saveCLPLResponse = (isDiscontinued, isRetry) => async (dispatch, getStore) => {
    const state = getStore();
    const formId = selectors.getMazeFormId(state);
    const selectedResponses = selectors.getMazeSelectedResponses(state);
    const resultResponse = formatMazeResponses(
        selectedResponses,
        isDiscontinued,
    );

    if (isRetry) {
        await dispatch(getStudentResults());

        const result = selectors.findResultFor(state, { measure, formId });

        if (result) {
            return Promise.resolve();
        }
    }

    return dispatch(saveMeasureResponse(formId, resultResponse));
};
